// extracted by mini-css-extract-plugin
module.exports = {"main":"style-module__main___3mrQa","flash-container":"style-module__flash-container___1BUtT"};